import React from 'react';
import { useDragLayer } from 'react-dnd';
import CampaignCard from './CampaignCard';

/**
 * CustomDragLayer - Renders a custom drag preview that follows the cursor
 *
 * This component creates a drag preview that:
 * - Follows the cursor closely (no offset)
 * - Stays fully visible (no opacity fade)
 * - Shows the actual campaign card being dragged
 */
const CustomDragLayer = () => {
 const {
 itemType,
 isDragging,
 item,
 currentOffset,
 } = useDragLayer((monitor) => ({
 item: monitor.getItem(),
 itemType: monitor.getItemType(),
 isDragging: monitor.isDragging(),
 currentOffset: monitor.getSourceClientOffset(),
 }));

 // Don't render if not dragging
 if (!isDragging || itemType !== 'CAMPAIGN_CARD') {
 return null;
 }

 // Position the drag preview at cursor location
 const layerStyles = {
 position: 'fixed',
 pointerEvents: 'none',
 zIndex: 9999,
 left: 0,
 top: 0,
 width: '100%',
 height: '100%',
 };

 const getItemStyles = (currentOffset) => {
 if (!currentOffset) {
 return {
 display: 'none',
 };
 }

 const { x, y } = currentOffset;
 const transform = `translate(${x}px, ${y}px) rotate(2deg)`;

 return {
 transform,
 WebkitTransform: transform,
 };
 };

 return (
 <div style={layerStyles}>
 <div className="w-80" style={getItemStyles(currentOffset)}>
 <CampaignCard
 campaign={item.campaign}
 stage={item.currentStage}
 onClick={() => {}}
 onSettingsClick={() => {}}
 isMobile={false}
 />
 </div>
 </div>
 );
};

export default CustomDragLayer;
